import { render } from "./RootCurvatureQuestion.vue?vue&type=template&id=1243003a&scoped=true"
import script from "./RootCurvatureQuestion.vue?vue&type=script&lang=js"
export * from "./RootCurvatureQuestion.vue?vue&type=script&lang=js"

import "./RootCurvatureQuestion.vue?vue&type=style&index=0&id=1243003a&lang=scss&scoped=true"

import exportComponent from "/src/clientapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1243003a"]])

export default __exports__